import { PostType } from '@prisma/client';
import { Link, useLoaderData } from 'react-router';
import SponsorshipsSection from '#app/components/sponsorship-section.tsx';
import WorkWithMeSection from '#app/components/work-with-me.tsx';
import { getRecentPost } from '#app/utils/posts.server.ts';
import { type Route } from './+types/index';

export const meta: Route.MetaFunction = () => {
	var title = "JaseOwns.com";
	var description = "JaseOwns.com is the online dumping ground of Jason Ramsey and includes ramblings of an internet ⭐ star. He's a streamer, dreamer, developer, gamer, husband and father who has been a nerd owning people on the internet since dial up 🖥️☎️";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/jase.gif"},
		{ property: "og:image:alt", content: "JaseOwns Blinking"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };

export const loader = async () => {
	const mostRecentVideo = await getRecentPost(PostType.VIDEO)
	return { mostRecentVideo }
}

export default function Index() {
	const { mostRecentVideo } = useLoaderData();
	return (
		<main className="container mx-auto font-light text-black dark:text-white">
			{HeroSection()}
			<div className="section-container section-container-border-t">
				<h3>Most recent JaseOwns YouTube video</h3>
				<Link className={`hover:bg-slate-500 p-6 text-center justify-center md:text-left underline text-2xl flex flex-col md:flex-row md:text-3xl py-5`} to={`/videos/${mostRecentVideo.slug}`}>
					<img loading="lazy" className="w-full md:mx-auto md:max-w-md flex-col md:flex-row" src={`https://img.youtube.com/vi/${mostRecentVideo.youtubeId}/0.jpg`} alt={`${mostRecentVideo.title} thumbnail`} />
					<div className="mt-6 mx-2 md:mx-8 text-center">{mostRecentVideo.title}</div>
				</Link>
				<div className="mt-6 mx-2 md:mx-8 text-center">
					{mostRecentVideo.snippet} <Link to={`/videos/${mostRecentVideo.slug}`} className="underline">View more details</Link>
				</div>
			</div>
			<SponsorshipsSection />
			<WorkWithMeSection />
			{RecentSection()}
			{ThoughtsSection()}
			{SnippetsSection()}
			{FeaturesSection()}
		</main>
	)
}

const RecentSection = () => {
	return <div id="recently">


		<div className="section-container section-container-background-alt">
			<h3>Life as a developer</h3>
			<p className="max-w-3xl mx-auto text-xl mb-10 text-center">
				I started my professional career as a web developer in 2005, at 20 years old, and stayed with the same company for nearly two decades - growing through different roles and coding languages.
			</p>
			<p className='font-bold italic max-w-3xl mx-auto text-xl mb-10 text-center'>
				What are you working on now? I'm going all in on working for myself: content creation, streaming, side gigs, and building my own products.
			</p>
			<div className="mt-10 flex items-center justify-center gap-x-6">
            <Link to="/support"
              className="w-full bg-youtube-color md:max-w-1/3 mb-8 p-4 px-8 text-white rounded-full shadow-lg duration-200 hover:opacity-80"
            >
              Support the dream
            </Link>
          </div>
			{/* <div className='flex flex-col md:flex-row'>
			<Link to="/support" className="mb-8 p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">Show Support</Link>
			<Link to="/work-with-me" className="mb-8 p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">Work with me</Link>
			</div> */}
		</div>
	</div>
}

const ThoughtsSection = () => {
	return <div id="thoughts">
		<div className="section-container mb-24">
			<h3>From playing a game to developing a career</h3>
			<p className="max-w-3xl mx-auto text-xl mb-10 text-center">
				My journey started at age 12, learning HTML from a book my dad gave me. Since then, I've been designing slick automation tools and building solid backends — always aiming for secure, seamless, and actually enjoyable experiences.
			</p>
			<p className='font-bold italic max-w-3xl mx-auto text-xl mb-10 text-center'>
				^ Is an AI-assisted intro better than just saying "Nerd likes computers"?
			</p>
			<Link to="/about" className="p-4 px-8 text-white rounded-full shadow-lg bg-cyan-600 dark:bg-cyan-800 duration-200 hover:opacity-80">Learn more about Jase</Link>
		</div>
	</div>
}

const FeaturesSection = () => {
	return <div id="features">
		<div className="section-container my-20">
		</div>
	</div>
}

const SnippetsSection = () => {
	return <div id="snippets">
		<div className="section-container section-container-border-t">
			<h3>Jase Owns Projects</h3>
			<p className="max-w-3xl mx-auto text-xl text-center">
				If you play Ultima Online, you might know me as "Script Daddy." Be sure to check out my{' '}
					<Link
						className="underline underline-offset-2 hover:underline-offset-4 hover:bg-blue-800/80"
						to="/gaming/ultima-online"
					>
						Ultima Online section
					</Link>{' '}
					and maybe give me a thumbs up while you're at it! 👍
			</p>
			<div className="relative flex flex-col md:flex-row md:space-x-32">
				<img className="mt-8 md:float-left md:h-96 md:mx-auto md:my-16" src="/images/uo_home_dragon2.gif" alt="dragon fighting jaseowns holding a shield" />
				<div className="mx-auto my-16 md:my-auto text-left flex flex-col gap-y-12">
					<div>
						<h5 className="mb-2 text-2xl font-bold">Video Content</h5>
						<p className="max-w-md">
							Check out my <Link to="/videos" className="underline">YouTube videos</Link> to learn more about Ultima Online and Razor.
						</p>
					</div>
					<div>
						<h5 className="mb-2 text-2xl font-bold">UORazorScripts.com</h5>
						<p className="max-w-md">
							Search community driven script content and learn how to make your own scripts.
						</p>
					</div>
						<div>
						<h5 className="mb-2 text-2xl font-bold">UOAddicts.com</h5>
						<p className="max-w-md">
							Search a list of all the servers out there.  Connect with other players and find your next favorite server or build.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
}

const HeroSection = () => {
	return <div id="hero" className="md:mt-32">
		<div className="section-container">
			<h3>Jase <i>OWNS</i> and he has a website to prove it!</h3>
			<img src="/images/emotes/hype_2048.png" alt="hype emote" className='h-24 float-left m-4 mb-8 md:m-8' />
			<img src="/images/emotes/excited_2048.png" alt="excited emote" className='h-24 float-right m-4 mb-8 md:m-8' />

			<p className="max-w-3xl mt-10 mx-auto text-2xl">
				JaseOwns.com is the online dumping ground of Jason Ramsey and includes ramblings of an internet ⭐ star. He's a streamer, dreamer, developer, gamer, husband and father who has been a nerd owning people on the internet since dial up 🖥️☎️ 
			</p>
			<div className="button-container mt-10">
				<a href="https://youtube.com/jaseowns/live" className="p-4 px-8 rounded-full shadow-lg bg-youtube-color duration-200 hover:opacity-80">
					Watch on YouTube
				</a>
				<a href="https://twitch.tv/jaseowns" className="p-4 px-8 rounded-full shadow-lg bg-twitch-color duration-200 hover:opacity-80">
					Watch on Twitch
				</a>
			</div>

		</div>
	</div>
}


// import {
// 	Tooltip,
// 	TooltipContent,
// 	TooltipProvider,
// 	TooltipTrigger,
// } from '#app/components/ui/tooltip.tsx'
// import { cn } from '#app/utils/misc.tsx'
// import { type Route } from './+types/index.ts'
// import { logos } from './logos/logos.ts'

// export const meta: Route.MetaFunction = () => [{ title: 'JaseOwns.com' }]

// // Tailwind Grid cell classes lookup
// const columnClasses: Record<(typeof logos)[number]['column'], string> = {
// 	1: 'xl:col-start-1',
// 	2: 'xl:col-start-2',
// 	3: 'xl:col-start-3',
// 	4: 'xl:col-start-4',
// 	5: 'xl:col-start-5',
// }
// const rowClasses: Record<(typeof logos)[number]['row'], string> = {
// 	1: 'xl:row-start-1',
// 	2: 'xl:row-start-2',
// 	3: 'xl:row-start-3',
// 	4: 'xl:row-start-4',
// 	5: 'xl:row-start-5',
// 	6: 'xl:row-start-6',
// }

// export default function Index() {
// 	return (
// 		<main className="font-poppins grid h-full place-items-center">
// 			<div className="grid place-items-center px-4 py-16 xl:grid-cols-2 xl:gap-24">
// 				<div className="flex max-w-md flex-col items-center text-center xl:order-2 xl:items-start xl:text-left">
// 					<a
// 						href="https://www.epicweb.dev/stack"
// 						className="animate-slide-top xl:animate-slide-left [animation-fill-mode:backwards] xl:[animation-delay:0.5s] xl:[animation-fill-mode:backwards]"
// 					>
// 						<svg
// 							className="text-foreground size-20 xl:-mt-4"
// 							xmlns="http://www.w3.org/2000/svg"
// 							fill="none"
// 							viewBox="0 0 65 65"
// 						>
// 							<path
// 								fill="currentColor"
// 								d="M39.445 25.555 37 17.163 65 0 47.821 28l-8.376-2.445Zm-13.89 0L28 17.163 0 0l17.179 28 8.376-2.445Zm13.89 13.89L37 47.837 65 65 47.821 37l-8.376 2.445Zm-13.89 0L28 47.837 0 65l17.179-28 8.376 2.445Z"
// 							></path>
// 						</svg>
// 					</a>
// 					<h1
// 						data-heading
// 						className="animate-slide-top text-foreground xl:animate-slide-left mt-8 text-4xl font-medium [animation-delay:0.3s] [animation-fill-mode:backwards] md:text-5xl xl:mt-4 xl:text-6xl xl:[animation-delay:0.8s] xl:[animation-fill-mode:backwards]"
// 					>
// 						<a href="https://www.epicweb.dev/stack">The Epic Stack</a>
// 					</h1>
// 					<p
// 						data-paragraph
// 						className="animate-slide-top text-muted-foreground xl:animate-slide-left mt-6 text-xl/7 [animation-delay:0.8s] [animation-fill-mode:backwards] xl:mt-8 xl:text-xl/6 xl:leading-10 xl:[animation-delay:1s] xl:[animation-fill-mode:backwards]"
// 					>
// 						Check the{' '}
// 						<a
// 							className="underline hover:no-underline"
// 							href="https://github.com/epicweb-dev/epic-stack/blob/main/docs/getting-started.md"
// 						>
// 							Getting Started guide
// 						</a>{' '}
// 						file for how to get your project off the ground!
// 					</p>
// 				</div>
// 				<ul className="mt-16 flex max-w-3xl flex-wrap justify-center gap-2 sm:gap-4 xl:mt-0 xl:grid xl:grid-flow-col xl:grid-cols-5 xl:grid-rows-6">
// 					<TooltipProvider>
// 						{logos.map((logo, i) => (
// 							<li
// 								key={logo.href}
// 								className={cn(
// 									columnClasses[logo.column],
// 									rowClasses[logo.row],
// 									'animate-roll-reveal [animation-fill-mode:backwards]',
// 								)}
// 								style={{ animationDelay: `${i * 0.07}s` }}
// 							>
// 								<Tooltip>
// 									<TooltipTrigger asChild>
// 										<a
// 											href={logo.href}
// 											className="grid size-20 place-items-center rounded-2xl bg-violet-600/10 p-4 transition hover:-rotate-6 hover:bg-violet-600/15 sm:size-24 dark:bg-violet-200 dark:hover:bg-violet-100"
// 										>
// 											<img src={logo.src} alt="" />
// 										</a>
// 									</TooltipTrigger>
// 									<TooltipContent>{logo.alt}</TooltipContent>
// 								</Tooltip>
// 							</li>
// 						))}
// 					</TooltipProvider>
// 				</ul>
// 			</div>
// 		</main>
// 	)
// }
